import { useSearchParams } from 'react-router';
import type { SubAgreementPublicState } from '@hts/shared';

// Bundled with the app, not pulled from Webflow's CDN. The company is off Webflow;
// an external host we no longer pay for is one lapsed invoice away from a
// broken logo on a customer-facing page.
const LOGO_URL = '/hts-logo-white.png';

type Branch = 'pending_terms_review' | 'standard' | 'unknown';

function branchFor(state: string | null): Branch {
  if (state === 'pending_terms_review') return 'pending_terms_review';
  if (
    state === 'confirming_issue' ||
    state === 'ready_to_sign' ||
    state === 'terms_rejected' ||
    state === 'issue_delayed' ||
    state === 'signed_pending_hts' ||
    state === 'complete'
  ) {
    return 'standard';
  }
  return 'unknown';
}

export function ThankYouPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const statusUrl = token ? `/status/${token}` : null;
  const agreementState = params.get('agreementState') as SubAgreementPublicState | null;
  const branch = branchFor(agreementState);

  return (
    <div className="app-container">
      <header className="app-header">
        <img src={LOGO_URL} alt="Harris Technology Services" />
        <h1>Subcontractor Onboarding</h1>
      </header>

      <main className="app-main">
        <div className="card status-card" data-thankyou-branch={branch}>
          <div
            style={{ fontSize: 48, marginBottom: 16 }}
            aria-hidden="true"
          >
            &#10003;
          </div>

          {branch === 'pending_terms_review' ? (
            <>
              <h2 style={{ color: '#0D2152', marginBottom: 8 }}>Application received</h2>
              <p
                style={{
                  color: '#4A4A4A',
                  marginBottom: 24,
                  maxWidth: 400,
                  margin: '0 auto 24px',
                }}
              >
                Thank you for your interest in partnering with Harris Technology Services.
                We'll review your payment terms request and email you. You don't need to do
                anything right now.
              </p>
              <p style={{ marginTop: 8, fontSize: 13, color: '#6B7280' }}>
                HTS will review your request before preparing any agreement.
              </p>
            </>
          ) : (
            <>
              <h2 style={{ color: '#0D2152', marginBottom: 8 }}>Application Submitted!</h2>
              <p
                style={{
                  color: '#4A4A4A',
                  marginBottom: 24,
                  maxWidth: 400,
                  margin: '0 auto 24px',
                }}
              >
                Thank you for your interest in partnering with Harris Technology Services.
                You will receive an email from DocuSign shortly with the Master Subcontractor
                Agreement for your signature. Once signed, our team will review your
                application.
              </p>
            </>
          )}

          {statusUrl && (
            <a href={statusUrl} className="btn btn-primary" style={{ textDecoration: 'none' }}>
              Check Application Status
            </a>
          )}

          <p style={{ marginTop: 24, fontSize: 13, color: '#9CA3AF' }}>
            A confirmation email has been sent to the address you provided.
          </p>
        </div>
      </main>

      <footer className="app-footer">
        <p>
          &copy; {new Date().getFullYear()} Harris Technology Services &bull;{' '}
          <a href="https://hts.pro">hts.pro</a>
        </p>
      </footer>
    </div>
  );
}